var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
import { useSafeId } from '../../../core/hooks/useSafeId';
/**
 * @tdr
 */
export var Israel = svgIcon(function (props) {
    var id1 = useSafeId();
    var id2 = useSafeId();
    return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("g", { clipPath: "url(#".concat(id1, ")") },
            React.createElement("g", { clipPath: "url(#".concat(id2, ")") },
                React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M14.571 12H-2.57V0h17.142v12Z", clipRule: "evenodd" }),
                React.createElement("path", { fill: "#00C", fillRule: "evenodd", d: "M14.571 10.875H-2.57V9.3h17.142v1.575Z", clipRule: "evenodd" }),
                React.createElement("path", { fill: "#00C", d: "M-2.571 2.7h17.142V1.12H-2.57V2.7Z" }),
                React.createElement("path", { fill: "#00C", fillRule: "evenodd", d: "m3.387 7.522.88-1.53-.87-1.512 1.736.006.837-1.454.86 1.46 1.783.007-.89 1.51.88 1.495-1.766.006-.86 1.458-.835-1.452-1.755.006Zm.01-3.042h-.001v-.002l.001.002Zm2.094.019.992-.002-.502-.83-.49.832H5.49h.002ZM4.465 6.362l-.509.844.961-.002-.452-.844v.002Zm-.5-1.558.966.007-.464.85-.501-.857Zm3.544 1.57.49.832-.977-.012.487-.82Zm.48-1.57-.965.007.464.85.502-.857Zm-2.678 0-.666 1.204.675 1.18 1.238.027.75-1.207-.694-1.218-1.303.011v.003Zm.18 2.653H5.49h.002Zm0 0 .992.004-.502.828-.49-.832Z", clipRule: "evenodd" }))),
        React.createElement("rect", { width: "11.7", height: "11.7", x: ".15", y: ".15", stroke: "#53565A", strokeWidth: ".3", rx: "5.85" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: id1 },
                React.createElement("rect", { width: "12", height: "12", fill: "#fff", rx: "6" })),
            React.createElement("clipPath", { id: id2 },
                React.createElement("path", { fill: "#fff", d: "M-2.571 0h17.142v12H-2.571z" })))));
});
//# sourceMappingURL=Israel.js.map